import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CartService } from '@services/cart.service';
import { MenuItemModel } from '@shared/models/menu-item.model';
import { RouteParamsInterface } from '@shared/models/routeParams.interface';
import { LanguageService } from '@shared/services/language.service';
import { OrderService } from '@shared/services/order/order.service';

@Component({
    selector: 'app-add-order-button',
    templateUrl: './add-order-button.component.html',
    styleUrls: ['./add-order-button.component.scss'],
    standalone: false
})
export class AddOrderButtonComponent implements OnInit {
  @Input() isItemsToOrder:boolean = false;
  @Input() tableIdInput: string | null = null;
  @Input() orderIdInput: string | null = null;
  @Input() returnUrlInput: string | null = null;
  @Input() closeOnSuccess: boolean = false;
  @Output() orderCompleted = new EventEmitter<string>();
  quantity = 0;
  isBrowser: boolean = false;
  cartProducts: MenuItemModel[] = [];
  tableId: string = '';
  orderId: string = '';
  isLoading: boolean = false;
  returnUrl: string | null = null;
  constructor(
    public cartService: CartService,
    private orderService: OrderService,
    private router: Router,
    private snackBar: MatSnackBar,
    public language: LanguageService,
    private route: ActivatedRoute
  ) {

  }

  ngOnInit() {
    if(this.isItemsToOrder) {
      const params = this.route.snapshot.params as RouteParamsInterface;
      this.orderId = this.orderIdInput || params.order_id;
    } else {
      const params = this.route.snapshot.params as RouteParamsInterface;
      this.tableId = this.tableIdInput || params.table_id;
      this.returnUrl = this.returnUrlInput || this.route.snapshot.queryParamMap.get('returnUrl');
      this.cartService.updateCartQuantity();
      this.cartService.updateTotalPrice();
    }
  }


  addOrder() {
    this.isLoading=true;
    const orderItems: { id?: string; notes?: string }[] = [];
    this.cartProducts = this.readCartProducts();
    for (const item of this.cartProducts) {
      orderItems.push({ id: item.id, notes: item.notes });
    }
    const order = {
      restaurant_table_id: this.tableId,
      order_items: orderItems,
    };
    if(this.isItemsToOrder) {
      this.orderService.addItemToSpecificOrder(this.orderId, order).subscribe({
        next: res => {
          const orderId= res.data.id;
          localStorage.removeItem('cart');
          this.navigateAfterOrderCreated(orderId);
          this.isLoading= false;
        },
        error: err => {
          this.isLoading= false;
          this.snackBar.open(err.message, '', {
            duration: 20000,
            panelClass: ['snackbar'],
          });
        },
      });
    } else {
      this.orderService.addOrder(order).subscribe({
        next: res => {
          const orderId= res.data.id;
          localStorage.removeItem('cart');
          this.navigateAfterOrderCreated(orderId);
          this.isLoading= false;
        },
        error: err => {
          this.isLoading= false;
          this.snackBar.open(err.message, '', {
            duration: 20000,
            panelClass: ['snackbar'],
          });
        },
      });
    }

  }

  private readCartProducts(): MenuItemModel[] {
    const cartProduct = localStorage.getItem('cart');
    if (!cartProduct) {
      return [];
    }

    try {
      const parsed = JSON.parse(cartProduct);
      if (Array.isArray(parsed)) {
        return parsed as MenuItemModel[];
      }
    } catch (error) {
      console.warn('Invalid cart data found in localStorage', error);
    }

    localStorage.removeItem('cart');
    localStorage.removeItem('cartTimestamp');
    return [];
  }

  private navigateAfterOrderCreated(orderId: string) {
    if (this.closeOnSuccess) {
      this.orderCompleted.emit(orderId);
      return;
    }

    if (this.returnUrl?.startsWith('/tables/')) {
      this.router.navigateByUrl(this.returnUrl);
      return;
    }

    this.router.navigate([`/orders/${orderId}`]);
  }
}
